import { gsap, Power2 } from 'gsap'
import {loadElementLottie, playLottie} from './lottie'
import { goToHash } from './go-to-hash'
import {getCookie, setCookie} from "./cookies";
import {heroAnimationsAfterLoader} from "../blocks/hero";
import {heroPhotoVideoAnimationsAfterLoader} from "../blocks/hero-photo-video";

let preloaderPage = $('#preloader')

if (preloaderPage.length) {

  setCookie('preloader_showed_'+ preloaderPage.data('page-name'))

  setTimeout(function(){
    loadElementLottie($('.js-preloader-lottie'))
  }, 100)


  let globalHash = window.location.hash
  if (globalHash) goToHash(globalHash)

  let tl = new gsap.timeline()
  tl.to('.js-preloader-logo', {opacity: 1, top: 0, duration: 1.2})
  tl.to('.js-preloader-progress', {top: 0, duration: 0.4, opacity: 1,}, '<')


  let pageLoaded = 0
  let minimumPreloadTimeCompleted = 0
  let minimumPreloadTime = 1500

  function runPageLoadedFunctions() {
    if (!pageLoaded) return false
    if (!minimumPreloadTimeCompleted) return false

    gsap.to('.js-preloader-logo', {top: 0, duration: 1.2})
    gsap.to('.js-preloader-lottie', {scale: 1, duration: 1.2})
    gsap.to('.js-preloader-progress', {opacity: 0, scale: 0.4, duration: 0.4})

    gsap.fromTo('#preloader', {
      yPercent: 0
    }, {
      yPercent: -100,
      duration: 1.2,
      onComplete: () => {
        // $('.js-header-logo').css('opacity', 1)
        // $('.js-preloader-logo').hide()

        heroAnimationsAfterLoader()
        heroPhotoVideoAnimationsAfterLoader()

      }
    })

  }

  $(window).on('load', function () {
    pageLoaded = 1
    runPageLoadedFunctions()
    setCookie('preloader_showed_' + preloaderPage.data('page-name'))
  })

  setTimeout(function () {
    minimumPreloadTimeCompleted = 1
    runPageLoadedFunctions()
  }, minimumPreloadTime)


} else {
  gsap.to('.js-header-logo', {opacity: 1, duration: 0.4})
  setTimeout(function(){
    heroAnimationsAfterLoader()
    heroPhotoVideoAnimationsAfterLoader()
  }, 400)
}
